import React from 'react';
import AdminNavigation from './AdminNavigation';
export default function AsideMenu(){return (
        <aside className="w-48 md:w-64 shrink-0 min-h-screen bg-admin-surface border-r border-admin-line flex flex-col">
            <div className="h-16 flex items-center gap-3 px-4 border-b border-admin-line">
                <div className="w-9 h-9 rounded-xl bg-admin-primary flex items-center justify-center flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l8 3v7c0 5-5 8-8 10-3-2-8-5-8-10V5z" fill="none" stroke="currentColor" strokeWidth="1.6" /><circle cx="11" cy="10" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.6" /><path d="M14 13l3 3" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                    </svg>
                </div>
                <span className="text-lg font-semibold text-admin-heading">
                    SES
                </span>
            </div>

            <AdminNavigation />
        </aside>
);}
